var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FB8C00",
    d: "m16.42 8.7 1.51-3.23 1.94.9-1.5 3.24-1.95-.9Zm-8.3-2.33 1.52 3.24 1.94-.9-1.51-3.24-1.94.9Zm11.25 12.27a5.8 5.8 0 1 0-10.73 0 11.62 11.62 0 0 1 10.73 0Zm-13.4-3.25-3.45-.92.55-2.07 3.45.92-.56 2.07Zm18.96-3-3.45.93.55 2.07 3.45-.92-.55-2.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreMarket);
export default __webpack_public_path__ + "static/media/PreMarket.6dabbfb07b584cd6e6600a6ab75e9545.svg";
export { ForwardRef as ReactComponent };